import { EOnboardingChosenReason, EOnboardingDiscoverySource } from '@constants';

export const StudentOnboardingPageTranslations = {
  START: {
    es: 'Empezar',
    en: 'Start',
    cat: 'Començar',
    eus: 'Hasi',
    pt: 'Começar'
  },
  CONTINUE: {
    es: 'Continuar',
    en: 'Continue',
    cat: 'Continuar',
    eus: 'Jarraitu',
    pt: 'Continuar'
  },
  WELCOME_ONBOARDING_TITLE: {
    es: '¡Hola, ',
    en: 'Hello, ',
    cat: '¡Hola, ',
    eus: '¡Kaixo, ',
    pt: 'Olá, '
  },
  WELCOME_ONBOARDING_SUBTITLE_UNI: {
    es: 'Ya estás un paso más cerca de la uni.',
    en: 'You are one step closer to your university.',
    cat: 'Estàs un pas més proper a la universitat.',
    eus: 'Unibertsitaterako urrats bat gertuago zaude orain.',
    pt: 'Estás a um passo mais perto da universidade.'
  },
  WELCOME_ONBOARDING_SUBTITLE_UNI_2: {
    es: 'Para ayudarte a conseguir la nota que necesitas, queremos conocerte un poco mejor.',
    en: 'To help you get the grade you need, we want to get to know you a little better.',
    cat: 'Per ajudar-te a conseguir la nota que necessites, volem conèixer-te un poc millor.',
    eus: 'Zure behar dituzun nota lortzeko, gurekin geroago batzuk ezagutu nahi dugu.',
    pt: 'Para ajudar-te  a conseguir a nota que precisas, queremos conhecer-te um pouco melhor.'
  },
  WELCOME_ONBOARDING_SUBTITLE_PCE: {
    es: 'Estás dando un gran paso hacia tu futuro en España.',
    en: 'You are taking a big step towards your future in Spain.',
    cat: 'Estàs donant un gran pas cap a el teu futur a Espanya.',
    eus: 'Espainiako zure etorkizunera urrats bat ematen duzu.',
    pt: 'Tu estás a dar um grande passo para o teu futuro na Espanha.'
  },
  WELCOME_ONBOARDING_SUBTITLE_PCE_2: {
    es: 'Para ayudarte a entrar en la universidad con la mejor preparación, queremos conocerte un poco mejor.',
    en: 'To help you get into university with the best preparation, we want to get to know you a little better.',
    cat: 'Per ajudar-te a entrar a la universitat amb la millor preparació, volem conèixer-te un poc millor.',
    eus: 'Zure unibertsitatean sartzeko, gurekin geroago batzuk ezagutu nahi dugu.',
    pt: 'Para ajudar-te a entrar na universidade com a melhor preparação, queremos conhecer-te um pouco melhor.'
  },
  WELCOME_ONBOARDING_SUBTITLE_OTHER: {
    es: 'Para que tu experiencia en el campus sea única, cuéntanos un poco más sobre ti.',
    en: 'To make your experience on campus unique, tell us a little more about yourself.',
    cat: 'Per fer que la teva experiència al campus sigui única, conta´ns un poc més sobre tu.',
    eus: 'Zure etorkizunera urrats bat ematen duzu.',
    pt: 'Para tornar a tua experiência no campus única, conta-nos um pouco mais sobre ti.'
  },
  WELCOME_ONBOARDING_SUBTITLE_3: {
    es: 'Dale al botón y empecemos.',
    en: 'Click the button and let´s get started.',
    cat: 'Clica el botó i anem-ho.',
    eus: 'Egin klik botoian eta hasi.',
    pt: 'Clica no botão e vamos começar.'
  },
  COMPLETE_PROFILE: {
    es: 'Completa tu <span>perfil</span>',
    en: 'Complete your <span>profile</span>',
    cat: 'Completa el teu <span>perfil</span>',
    eus: 'Zure profilua bete <span>perfil</span>',
    pt: 'Complete seu <span>perfil</span>'
  },
  NAME: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  PHONE_NUMBER: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefono',
    pt: 'Telefone'
  },
  IDENTITY_DOCUMENT: {
    es: 'DNI / NIE / Pasaporte',
    en: 'DNI / NIE / Passport',
    cat: 'DNI / NIE / Pasaport',
    eus: 'DNI / NIE / Pasaporta',
    pt: 'CC / Passaporte'
  },
  IDENTIFICATION_DOCUMENT_PLACEHOLDER: {
    es: 'Número de identidad',
    en: 'Identification number',
    cat: "Número d'identificació",
    eus: 'Identifikazio zenbakia',
    pt: 'Número de identificação'
  },
  DATE_OF_BIRTH: {
    es: 'Fecha de nacimiento',
    en: 'Date of birth',
    cat: 'Data de naixement',
    eus: 'Jaiotze data',
    pt: 'Data de nascimento'
  },
  BIRTH_COUNTRY: {
    es: 'País de nacimiento',
    en: 'Birth country',
    cat: 'País de naixement',
    eus: 'Jaiotze herrialdea',
    pt: 'País de nascimento'
  },
  BIRTH_COUNTRY_PLACEHOLDER: {
    es: 'España',
    en: 'Spain',
    cat: 'Espanya',
    eus: 'Espainia',
    pt: 'Espanha'
  },
  REQUIRED_NAME: {
    es: 'Por favor, completa el campo Nombre',
    en: 'Please complete the Name field',
    cat: 'Si us plau, completa el camp Nom',
    eus: 'Mesedez, bete Izena eremua',
    pt: 'Por favor, complete o campo Nome'
  },
  REQUIRED_FIRST_SURNAME: {
    es: 'Por favor, completa el campo primer apellido',
    en: 'Please complete the First surname field',
    cat: 'Si us plau, completa el camp Primer cognom',
    eus: 'Mesedez, bete Lehen abizena eremua',
    pt: 'Por favor, complete o campo Primeiro apelido'
  },
  REQUIRED_PHONE: {
    es: 'Por favor, completa el campo Teléfono',
    en: 'Please complete the Phone field',
    cat: 'Si us plau, completa el camp Telèfon',
    eus: 'Mesedez, bete Telefono eremua',
    pt: 'Por favor, complete o campo Telefone'
  },
  REQUIRED_IDENTIFICATION_DOCUMENT: {
    es: 'Por favor, completa el documento de identificación',
    en: 'Please complete the identification document',
    cat: "Si us plau, completa el document d'identificació",
    eus: 'Mesedez, bete identifikazio dokumentua',
    pt: 'Por favor, complete o documento de identificação'
  },
  REQUIRED_BIRTHDAY: {
    es: 'Por favor, indica tu fecha de nacimiento',
    en: 'Please enter your date of birth',
    cat: 'Si us plau, indica la teva data de naixement',
    eus: 'Mesedez, adierazi zure jaiotze data',
    pt: 'Por favor, informe sua data de nascimento'
  },
  REQUIRED_BIRTH_COUNTRY: {
    es: 'Por favor, selecciona tu país de nacimiento',
    en: 'Please select your birth country',
    cat: 'Si us plau, selecciona el teu país de naixement',
    eus: 'Mesedez, hautatu zure jaiotze herrialdea',
    pt: 'Por favor, selecione seu país de nascimento'
  },
  DEFINE_YOUR_GOAL: {
    es: '¡Todo listo! Definamos tu <span>objetivo</span>',
    en: "¡All set! Let's define your <span>goal</span>",
    cat: '¡Tot llest! Definim el teu <span>objectiu</span>',
    eus: 'Denak prest! Zure <span>helburua</span> definitzu',
    pt: '¡Tudo pronto! Vamos definir o teu <span>objetivo</span>'
  },
  BRANCH_GOAL: {
    es: '¿Qué <strong>rama</strong> quieres estudiar?',
    en: 'What <strong>branch</strong> do you want to study?',
    cat: 'Quina <strong>rama</strong> vols estudiar?',
    eus: 'Zer <strong>zirriborro</strong> ikastarazu nahi duzu?',
    pt: 'Qual é a tua principal <strong>área de estudo</strong>?'
  },
  CAREER_GOAL: {
    es: '¿Qué <strong>carrera</strong> te interesa?',
    en: 'What <strong>career</strong> do you want to study?',
    cat: 'Quina <strong>carrera</strong> vols estudiar?',
    eus: 'Zer <strong>karrera</strong> ikastarazu nahi duzu?',
    pt: 'Que <strong>curso</strong> queres estudar?'
  },
  UNIVERSITY_GOAL: {
    es: '¿Qué <strong>universidad</strong> te gustaría estudiar?',
    en: 'What <strong>university</strong> would you like to study?',
    cat: 'Quina <strong>universitat</strong> vols estudiar?',
    eus: 'Zer <strong>unibertsitate</strong> ikastarazu nahi duzu?',
    pt: 'Qual <strong>universidade</strong> gostarias de frequentar?'
  },
  STUDY_PLAN: {
    es: 'Diseña tu <span>plan de estudios</span>',
    en: 'Design your <span>study plan</span>',
    cat: 'Diseña el teu <span>plan d`estudis</span>',
    eus: 'Zure <span>ikastaro plan</span> diseinatu',
    pt: 'Personaliza o teu <span>plano de estudos</span>'
  },
  STUDY_PLAN_FINISH_DATE: {
    es: '¿En qué fecha te gustaría <strong>terminar de estudiar</strong> el temario?',
    en: 'When do you want to <strong>finish studying</strong> the syllabus?',
    cat: 'Quan vols <strong>acabar els teus estudis</strong> el temari?',
    eus: 'Zure ikastarakoak zein denbora amaitu nahi duzu temariari <strong>ikastaroak amaitu nahi duzu</strong>?',
    pt: 'Quando é que queres <strong>terminar os teus estudos</strong>?'
  },
  REST_WEEK_DAYS: {
    es: '¿Cuáles serán tus <strong>días de descanso</strong>?',
    en: 'What will be your <strong>rest days</strong>?',
    cat: 'Quins seràn els teus <strong>dies de descans</strong>?',
    eus: 'Zure <strong>irristo egunak</strong> zein izango dira?',
    pt: 'Quais serão os teus <strong>dias de descanso</strong>?'
  },
  REST_DATES: {
    es: 'Indica tus <strong>vacaciones</strong> o días en los que no estudiarás',
    en: 'How many days do you want <strong>vacations</strong>?',
    cat: 'Quants dies vols <strong>vacances</strong>?',
    eus: 'Adierazi zure <strong>oporrak</strong> edo ikasiko ez dituzun egunak',
    pt: 'Indica as <strong>férias</strong> ou os dias em que não vais estudar.'
  },
  YOU_HAVE_MASTER_DEGREE: {
    es: '¿Tienes el <span>Máster en Profesorado</span>?',
    en: 'Do you have a <span>Master in Teaching</span>?',
    cat: 'Tens un <span>Master en Professorat</span>?',
    eus: 'Zure <span>irakasle</span> bat dago?',
    pt: 'Tens o <span>Mestrado em Ensino</span>?'
  },
  YOU_HAVE_MASTER_DEGREE_DESCRIPTION: {
    es: 'El MAES (antiguo Máster CAP) es un <strong>título oficial habilitante</strong> que te permitirá convertirte en profesor de Educación Secundaria, Bachillerato, Ciclos Formativos de Grado Superior y en Escuelas Oficiales de Idiomas.',
    en: 'The MAES (former Master CAP) is an <strong>official title</strong> that will allow you to become a teacher of Secondary Education, Baccalaureate, Higher Vocational Training Cycles and Official Language Schools.',
    cat: 'El MAES (antigament Master CAP) és un <strong>títol oficial habilitant</strong> que et permetrà convertir-te en professor d´Educació Secundària, Batxillerat, Cicles Formatius de Grau Superior i en Escoles Oficials d´Idiomes.',
    eus: 'MAES (antiguo Máster CAP) dai <strong>títulu ofizial habilizatzailea</strong> da, zurek ikaslekoak bilaketa egiten lagunduko du.',
    pt: 'O MAES (antigo Máster CAP) é um <strong>título oficial habilitante</strong> que te permitirá converter-te em professor de Educação Secundária, Bacharelado, Ciclos Formativos de Grau Superior e Escolas Oficiais de Idiomas.'
  },
  YOU_HAVE_MASTER_DEGREE_DESCRIPTION_2: {
    es: 'Si tienes un <strong>Máster en Profesorado</strong>, puedes estudiar en <strong>Universidad</strong> o <strong>Instituto</strong>.',
    en: 'If you have a <strong>Master in Teaching</strong>, you can study in <strong>University</strong> or <strong>Institute</strong>.',
    cat: 'Si tens un <strong>Master en Professorat</strong>, pots estudiar en <strong>Universitat</strong> o <strong>Institut</strong>.',
    eus: 'Zure <strong>irakasle</strong> bat dago?',
    pt: 'Se tens um <strong>Mestrado em Ensino</strong>, podes estudar na <strong>Universidade</strong> ou no <strong>Instituto</strong>.'
  },
  DISCOVER_SOURCES: {
    es: '¿<span>Cómo</span> nos conociste?',
    en: '<span>How</span> did you find us?',
    cat: '<span>Com</span> ens trobeu?',
    eus: '<span>Nola</span> aurkitu zara?',
    pt: '<span>Como</span> é que nos conheceste?'
  },
  [EOnboardingDiscoverySource.GOOGLE]: {
    es: 'Búsqueda de Google',
    en: 'Google search',
    cat: 'Cerca de Google',
    eus: 'Google bilaketa',
    pt: 'Pesquisa no Google'
  },
  [EOnboardingDiscoverySource.SOCIAL_MEDIA]: {
    es: 'Redes sociales',
    en: 'Social media',
    cat: 'Xarxes socials',
    eus: 'Sare sozialak',
    pt: 'Redes sociais'
  },
  [EOnboardingDiscoverySource.ADVERTISEMENT]: {
    es: 'Publicidad en medios de comunicación',
    en: 'Advertisement in media',
    cat: 'Anuncis en mitjans de comunicació',
    eus: 'Sare sozialen argitalpenak',
    pt: 'Anúncio nos media'
  },
  [EOnboardingDiscoverySource.FRIEND]: {
    es: 'Recomendación de un amigo',
    en: 'Friend recommendation',
    cat: 'Recomendació d`un amic',
    eus: 'Lagunen erakundea',
    pt: 'Recomendação de um amigo'
  },
  [EOnboardingDiscoverySource.FLYER]: {
    es: 'Pancarta en la calle',
    en: 'Street flyer',
    cat: 'Flyer de la calle',
    eus: 'Urrutiko flyer',
    pt: 'Flyer na rua'
  },
  CHOSEN_REASONS: {
    es: '¿<span>Por qué</span> nos elegiste?',
    en: '<span>Why</span> did you choose us?',
    cat: '<span>Per què</span> ens vas triar?',
    eus: '<span>Zergatik</span> aukeratu gintuzten?',
    pt: '<span>Motivo</span> de escolha'
  },
  [EOnboardingChosenReason.COMPATIBILITY_WITH_WORK_AND_FAMILY]: {
    es: 'Compatibilidad con mi <strong>trabajo y/o vida familiar</strong>',
    en: 'Compatibility with my <strong>work and/or family life</strong>',
    cat: 'Compatibilitat amb el meu <strong>treball i/o la meva vida familiar</strong>',
    eus: 'Lana eta/edo bizitza familiariari <strong>dagokion</strong>',
    pt: 'Compatibilidade com o meu <strong>trabalho e/ou vida familiar</strong>'
  },
  [EOnboardingChosenReason.AFFORDABLE_PRICE]: {
    es: '<strong>Precio</strong> accesible',
    en: 'Affordable <strong>price</strong>',
    cat: 'Accessible <strong>preu</strong>',
    eus: '<strong>Prezio</strong> erabilgarria',
    pt: '<strong>Preço</strong> acessível'
  },
  [EOnboardingChosenReason.QUALITY_PLATFORM_AND_CONTENT]: {
    es: '<strong>Plataforma y contenido</strong> de calidad',
    en: 'Quality <strong>platform</strong> and <strong>content</strong>',
    cat: '<strong>Plataforma i contingut</strong> de qualitat',
    eus: '<strong>Plataforma</strong> eta <strong>edukia</strong> kualitatea',
    pt: '<strong>Plataforma</strong> e conteúdo de <strong>qualidade</strong>'
  },
  [EOnboardingChosenReason.PERSONALIZED_SUPPORT_AND_ATTENTION]: {
    es: '<strong>Acompañamiento</strong> y atención personalizada',
    en: 'Personalized <strong>support</strong> and attention',
    cat: '<strong>Acompañament</strong> i atenció personalitzada',
    eus: '<strong>Laguntza</strong> eta arreta pertsonalizatuak',
    pt: '<strong>Acompanhamento</strong> e atenção personalizada'
  },
  [EOnboardingChosenReason.FLEXIBILITY_TO_STUDY_AT_MY_RHYTHM]: {
    es: '<strong>Flexibilidad</strong> para estudiar a mi ritmo',
    en: '<strong>Flexibility</strong> to study at my rhythm',
    cat: '<strong>Flexibilitat</strong> per estudiar a mi ritme',
    eus: 'Arreta per ikastarazketa <strong>nire ritmora</strong>',
    pt: '<strong>Flexibilidade</strong> para estudar ao <strong>meu ritmo</strong>'
  },
  [EOnboardingChosenReason.EASY_VISA_PROCESS]: {
    es: 'Ayuda con trámites <strong>legales</strong>',
    en: '<strong>Legal</strong> help',
    cat: 'Ajuda <strong>legal</strong>',
    eus: 'Gauza legalaren <strong>laguntza</strong>',
    pt: 'Ajuda <strong>legal</strong>'
  },
  [EOnboardingChosenReason.FINANCIAL_OPTIONS]: {
    es: 'Opciones de <strong>financiación</strong>',
    en: 'Financial <strong>options</strong>',
    cat: 'Opcions de <strong>finançament</strong>',
    eus: '<strong>Finantzaketa</strong> aukerak',
    pt: 'Opções de <strong>financiamento</strong>'
  },
  YES: {
    es: 'Sí',
    en: 'Yes',
    cat: 'Sí',
    eus: 'Bai',
    pt: 'Sim'
  },
  NO: {
    es: 'No',
    en: 'No',
    cat: 'No',
    eus: 'Ez',
    pt: 'Não'
  },
  SUBJECT_NOTES: {
    es: 'Completa las <span>notas de las asignaturas</span> que estudiaste',
    en: 'Complete the <span>subject notes</span> you studied',
    cat: 'Completa les <span>notes de les assignatures</span> que estudies',
    eus: 'Zure ikastarako <span>ikastaroak</span> bete',
    pt: 'Completa as <span>notas das disciplinas</span> que estudaste'
  },
  YOUR_SITUATION: {
    es: 'Cuéntanos tu <span>situación actual</span>',
    en: 'Tell us your <span>current situation</span>',
    cat: 'Explica la teva <span>situació actual</span>',
    eus: 'Zure <span>uneko egoera</span> esan',
    pt: 'Conte-nos a sua <span>situação atual</span>'
  },
  NEED_VISA: {
    es: '¿Necesitas <strong>visado de estudiante</strong>?',
    en: 'Do you need a <strong>student visa</strong>?',
    cat: 'Necesites un <strong>visat d´estudiant</strong> per estudiar?',
    eus: 'Espainiako ikastaratzeko <strong>visa</strong> behar duzu?',
    pt: 'Precisas de um <strong>visto de estudante</strong>?'
  },
  HAS_HOMOLOGATION: {
    es: '¿Tienes tu <strong>título homologado</strong>?',
    en: 'Do you have your <strong>homologated title</strong>?',
    cat: 'Tens el teu <strong>títol homologat</strong>?',
    eus: 'Zure <strong>homologatutako izenburua</strong> duzu?',
    pt: 'Tens o teu <strong>título homologado</strong>?'
  },
  MADE_GRADE_EQUIVALENT: {
    es: '¿Has hecho la <strong>equivalencia de notas</strong>?',
    en: 'Have you made the <strong>grade equivalent</strong>?',
    cat: 'Has fet la <strong>equivalència de notes</strong>?',
    eus: 'Zure <strong>nota</strong> berdina egin duzu?',
    pt: 'Fizeste a <strong>equivalência de notas</strong>?'
  },
  CHOOSE_COURSES: {
    es: 'Elige los <span>cursos</span> que vas a estudiar',
    en: 'Choose the <span>courses</span> you want to study',
    cat: 'Tria les <span>assignatures</span> que vols estudiar',
    eus: 'Zure <span>ikastarakoak</span> aukeratu',
    pt: 'Escolhe as disciplinas que queres estudar'
  },
  FIELD_REQUIRED: {
    es: 'Por favor, rellena este campo',
    en: 'Please fill in this field',
    cat: 'Si us plau, omple aquest camp',
    eus: 'Ez da bete beharrezkoa',
    pt: 'Por favor, preencha este campo'
  },
  VALUE_BETWEEN_MIN_AND_MAX: {
    es: 'La nota debe estar entre {{min}} y {{max}}',
    en: 'The note must be between {{min}} and {{max}}',
    cat: 'La nota ha de ser entre {{min}} i {{max}}',
    eus: 'Ikastarako nota {{min}} eta {{max}} artean egon behar da',
    pt: 'O valor deve estar entre {{min}} e {{max}}'
  },
  PREPARE_FOR_THE_CHALLENGE: {
    es: 'Prepárate para el <span>reto</span>',
    en: 'Prepare for the <span>challenge</span>',
    cat: 'Prepareu-vos per al <span>reto</span>',
    eus: 'Zure <span>reto</span> prestatu',
    pt: 'Prepare-se para o <span>reto</span>'
  },
  AUTONOMOUS_COMMUNITY: {
    es: '¿En qué <strong>Comunidad Autónoma</strong> te presentas?',
    en: 'To which <strong>Autonomous Community</strong> do you present yourself?',
    cat: 'A quina <strong>Comunitat Autònoma</strong> es presenta?',
    eus: 'Zer <strong>Autonomoko Komunitatea</strong> zara?',
    pt: 'Para qual <strong>Comunidade Autónoma</strong> se apresenta?'
  },
  EXAM_GROUP: {
    es: '¿A qué <strong>exámenes</strong> quieres presentarte?',
    en: 'To which <strong>exams</strong> do you want to present yourself?',
    cat: 'A quin <strong>examen</strong> vols presentar-te?',
    eus: 'Zer <strong>examen</strong> zara?',
    pt: 'Para qual <strong>exame</strong> se apresenta?'
  },
  SELECT_DEGREE: {
    es: 'Selecciona un grado',
    en: 'Select a degree',
    cat: 'Tria un grau',
    eus: 'Grado aukeratu',
    pt: 'Selecione um grau'
  },
  SELECT_UNIVERSITY: {
    es: 'Selecciona una universidad',
    en: 'Select a university',
    cat: 'Tria una universitat',
    eus: 'Izenburua aukeratu',
    pt: 'Selecione uma universidade'
  },
  OTHER_DEGREE_PLACEHOLDER: {
    es: 'Nombre de la carrera',
    en: 'Degree name',
    cat: 'Nom del grau',
    eus: 'Karreraren izena',
    pt: 'Nome do curso'
  },
  OTHER_UNIVERSITY_PLACEHOLDER: {
    es: 'Nombre de la universidad',
    en: 'University name',
    cat: 'Nom de la universitat',
    eus: 'Izenburua',
    pt: 'Nome da universidade'
  },
  OTHER: {
    es: 'Otra',
    en: 'Other',
    cat: 'Altres',
    eus: 'Beste',
    pt: 'Outra'
  },
  SELECT_BRANCH: {
    es: 'Selecciona una rama',
    en: 'Select a branch',
    cat: 'Tria una branca',
    eus: 'Zer aukeratu',
    pt: 'Selecione uma rama'
  },

  WHAT_EXAM_GROUP_ARE_YOU_INTERESTED_IN: {
    es: '¿A qué <strong>exámenes</strong> quieres presentarte?',
    en: 'What <strong>exams</strong> are you interested in?',
    cat: 'Quins <strong>examens</strong> vols presentar-te?',
    eus: 'Zer <strong>examen</strong> zara?',
    pt: 'Para qual <strong>exame</strong> se apresenta?'
  },
  WILL_PARTICIPATE_IN_LIVE_CLASS: {
    es: '¿Vas a participar en las <strong>clases en directo</strong>?',
    en: 'Will you participate in the <strong>live classes</strong>?',
    cat: 'Participaràs en les <strong>classes en directe</strong>?',
    eus: 'Zure <strong>ikastarakoak</strong> aukeratu',
    pt: 'Vais participar nas <strong>aulas em direto</strong>?'
  },
  ALLWAYS_PARTICIPATE_IN_LIVE_CLASS: {
    es: 'Sí, siempre que pueda',
    en: 'Yes, always that I can',
    cat: 'Sí, sempre que pugui',
    eus: 'Bai, beti nago',
    pt: 'Sim, sempre que possa'
  },
  NO_PARTICIPATE_IN_LIVE_CLASS: {
    es: 'No, prefiero verlas después',
    en: 'No, I prefer to see them later',
    cat: 'No, prefereixo veure-les més tard',
    eus: 'Ez, geroago ikusi nahi dut',
    pt: 'Não, prefiro ver depois'
  },
  I_DONT_KNOW: {
    es: 'Aún no lo sé',
    en: 'I don´t know',
    cat: 'Encara no ho sé',
    eus: 'Ez dakit',
    pt: 'Ainda não sei'
  },
  STUDY_PLAN_FINISH_DATE_MESSAGE: {
    es: 'Tu próxima convocatoria es el <strong>{{date}}</strong>. Te recomendamos elegir esa fecha o una cercana para organizar mejor tu estudio.',
    en: 'Your next exam is on <strong>{{date}}</strong>. We recommend choosing that date or a nearby one to better organize your study.',
    cat: 'La teva pròxima convocatòria és el <strong>{{date}}</strong>. Te recomanem triar aquesta data o una propera per organitzar millor el teu estudi.',
    eus: 'Zure hurrengo emaitza <strong>{{date}}</strong> da. Ikastarako zure egiten duzun data aukeratu edo ondoagoa aukeratu.',
    pt: 'A data do próximo exame é <strong>{{date}}</strong>. Recomendamos escolher essa data ou uma próxima para organizares melhor o teu estudo.'
  },
  SIGN_CONTRACT: {
    es: 'Hagámoslo oficial 😄',
    en: "Let's make it official 😄",
    cat: 'Vamos fazer isso oficial 😄',
    eus: 'Gertu da! Zure sinatua behar da',
    pt: 'Vamos fazer isso oficial 😄'
  },
  SIGN_CONTRACT_SUBTITLE: {
    es: 'Necesitamos tu firma para completar tu inscripción.',
    en: 'We need your signature to complete your registration.',
    cat: 'Necessitem la teva signatura per completar la teva inscripció.',
    eus: 'Zure inscriptzioa betetzea zure sinatua behar da.',
    pt: 'Precisamos da sua assinatura para completar a sua inscrição.'
  },
  SIGN_CONTRACT_FOOTER: {
    es: 'Si necesitas ayuda, escríbenos a <span>atencionalalumno@ucademy.com</span> con el asunto “Contrato” y nos pondremos en contacto contigo lo antes posible.',
    en: 'If you need help, write to <span>atencionalalumno@ucademy.com</span> with the subject “Contract” and we will contact you as soon as possible.',
    cat: 'Si necessites ajuda, escriu a <span>atencionalalumno@ucademy.com</span> amb el tema “Contracte” i ens posarem en contacte amb tu tan aviat com sigui possible.',
    eus: 'Laguntza behar baduzu, idatzi <span>atencionalalumno@ucademy.com</span> eremuarekin “Kontratua” eta bizkortuago kontaktuan jarriko gara.',
    pt: 'Se precisares de ajuda, escreve para <span>atencionalalumno@ucademy.com</span> com o assunto “Contrato” e entraremos em contacto contigo o mais rápido possível.'
  },
  LOADING_CONTRACT_TITLE: {
    es: 'Preparando tu contrato',
    en: 'Preparing your contract',
    cat: 'Preparant el teu contracte',
    eus: 'Zure kontratua prestatu',
    pt: 'Preparando seu contrato'
  },
  LOADING_APP_TITLE: {
    es: 'Validando tu contrato...',
    en: 'Validating your contract...',
    cat: 'Validant el teu contracte...',
    eus: 'Zure kontratua balioztatzen',
    pt: 'Validando seu contrato...'
  },
  WELCOME_MESSAGE: {
    es: 'Muchas gracias y bienvenido a Ucademy! 😁',
    en: 'Thank you very much and welcome to Ucademy! 😁',
    cat: 'Moltes gràcies i benvingut a Ucademy! 😁',
    eus: 'Mila esker eta ongi etorri Ucademy! 😁',
    pt: 'Muito obrigado e bem-vindo ao Ucademy! 😁'
  },
  SUBJECTS_TO_VALIDATE: {
    es: '¿Tienes <strong>asignaturas para convalidar</strong>?',
    en: 'Do you have <strong>subjects to validate</strong>?',
    cat: 'Tens <strong>assignatures per validar</strong>?',
    eus: 'Zure <strong>ikastarakoak</strong> berdina egin duzu?',
    pt: 'Tens <strong>disciplinas para validar</strong>?'
  },
  SUBJECTS_TO_VALIDATE_DESCRIPTION: {
    es: 'Indica si ya has cursado algunas asignaturas en otro centro.',
    en: 'Indicate if you have already studied some subjects in another center.',
    cat: 'Indica si has cursat algunes assignatures en un altre centre.',
    eus: 'Mesedez, adierazi beste eskola batean ikasgairik ikasi duzun ala ez.',
    pt: 'Indique se já cursou algumas disciplinas em outro centro.'
  },
  SUBJECTS_TO_VALIDATE_MESSAGE: {
    es: 'Te enviaremos un correo para que nos indiques qué asignaturas deseas convalidar.',
    en: 'We will send you an email to indicate which subjects you want to validate.',
    cat: 'Enviarem un correu electrònic per indicar quines assignatures vols validar.',
    eus: 'Baliozkotu nahi dituzun gaiak zeintzuk diren esateko eskatuz mezu elektroniko bat bidaliko dizugu.',
    pt: 'Vamos enviar-te um email para nos dizeres quais as disciplinas que queres validar.'
  },
  EXAM_GROUPS_WARNING: {
    es: 'Si no ves la convocatoria que buscas, puede que aún no esté publicada. No te preocupes: te avisaremos en cuanto salga.',
    en: 'If you don´t see the exam you are looking for, it may not have been published yet. Don´t worry: we will let you know as soon as it is published.',
    cat: 'Si no veus la convocatòria que cerques, pot ser que encara no estigui publicada. No et preocupis: et notificarem tan aviat com surti.',
    eus: 'Zure bilatutako emaitza ez dagoela ikusi, agian ez da argitaratu oraindik. Egoera ez da gauza garrantzitsu: argitaratzean jakinaraziko dizugu.',
    pt: 'Se não encontrares a época de exame que procuras, pode ser que ainda não tenha sido publicada. Não te preocupes: avisaremos assim que sair.'
  },
  PHONE_NUMBER_PLACEHOLDER: {
    es: 'Escribe tu teléfono',
    en: 'Enter your phone number',
    cat: 'Escriu el teu telèfon',
    eus: 'Sartu zure telefonoa',
    pt: 'Introduza o seu número de telefone'
  },
  SELECT_PORTUGAL_REGION: {
    es: 'Selecciona una región',
    en: 'Select a region',
    cat: 'Tria una regió',
    eus: 'Hautatu eskualde bat',
    pt: 'Selecione uma região'
  },
  COMPLETE_PROFILE_SUBTITLE: {
    es: 'Estos datos se usarán en los procesos académicos. Asegúrate de que coincidan con tu documento oficial.',
    en: 'This data will be used in academic processes. Make sure it matches your official document.',
    cat: "Aquestes dades s'utilitzaran en els processos acadèmics. Assegura't que coincideixin amb el teu document oficial.",
    eus: 'Datu hauek prozesu akademikoetan erabiliko dira. Ziurtatu zure dokumentu ofizialarekin bat datozela.',
    pt: 'Estes dados serão usados nos processos acadêmicos. Certifique-se de que correspondem ao seu documento oficial.'
  },
  REQUIRED_FIELDS_NOTE: {
    es: 'Todos los campos marcados con asterisco son obligatorios.',
    en: 'All fields marked with an asterisk are required.',
    cat: 'Tots els camps marcats amb asterisc són obligatoris.',
    eus: 'Asteriskoz markatutako eremu guztiak derrigorrezkoak dira.',
    pt: 'Todos os campos marcados com asterisco são obrigatórios.'
  },
  GENERAL_INFORMATION: {
    es: 'Información general',
    en: 'General information',
    cat: 'Informació general',
    eus: 'Informazio orokorra',
    pt: 'Informação geral'
  },
  NAME_PLACEHOLDER: {
    es: 'Introduce tu nombre',
    en: 'Enter your name',
    cat: 'Introdueix el teu nom',
    eus: 'Sartu zure izena',
    pt: 'Introduza o seu nome'
  },
  FIRST_SURNAME: {
    es: 'Primer apellido',
    en: 'First surname',
    cat: 'Primer cognom',
    eus: 'Lehen abizena',
    pt: 'Primeiro apelido'
  },
  FIRST_SURNAME_PLACEHOLDER: {
    es: 'Introduce tu primer apellido',
    en: 'Enter your first surname',
    cat: 'Introdueix el teu primer cognom',
    eus: 'Sartu zure lehen abizena',
    pt: 'Introduza o seu primeiro apelido'
  },
  SECOND_SURNAME: {
    es: 'Segundo apellido',
    en: 'Second surname',
    cat: 'Segon cognom',
    eus: 'Bigarren abizena',
    pt: 'Segundo apelido'
  },
  SECOND_SURNAME_PLACEHOLDER: {
    es: 'Introduce tu segundo apellido',
    en: 'Enter your second surname',
    cat: 'Introdueix el teu segon cognom',
    eus: 'Sartu zure bigarren abizena',
    pt: 'Introduza o seu segundo apelido'
  },
  REQUIRED_SECOND_SURNAME: {
    es: 'Por favor, completa el campo Segundo apellido',
    en: 'Please complete the Second surname field',
    cat: 'Si us plau, completa el camp Segon cognom',
    eus: 'Mesedez, bete Bigarren abizena eremua',
    pt: 'Por favor, complete o campo Segundo apelido'
  },
  PHONE: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefonoa',
    pt: 'Telefone'
  },
  PHONE_PLACEHOLDER: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefonoa',
    pt: 'Telefone'
  },
  IDENTIFICATION_DOCUMENT: {
    es: 'Documento de identificación',
    en: 'Identification document',
    cat: "Document d'identificació",
    eus: 'Identifikazio dokumentua',
    pt: 'Documento de identificação'
  },
  REQUIRED_DOCUMENT_TYPE: {
    es: 'Por favor, selecciona el tipo de documento',
    en: 'Please select the document type',
    cat: 'Si us plau, selecciona el tipus de document',
    eus: 'Mesedez, hautatu dokumentu mota',
    pt: 'Por favor, selecione o tipo de documento'
  },
  REQUIRED_DOCUMENT_NUMBER: {
    es: 'Por favor, introduce el número de documento',
    en: 'Please enter the document number',
    cat: 'Si us plau, introdueix el número de document',
    eus: 'Mesedez, sartu dokumentu zenbakia',
    pt: 'Por favor, introduza o número do documento'
  },
  DOCUMENT_NUMBER_PLACEHOLDER: {
    es: 'Número de documento',
    en: 'Document number',
    cat: 'Número de document',
    eus: 'Dokumentu zenbakia',
    pt: 'Número do documento'
  },
  NATIONALITY: {
    es: 'Nacionalidad',
    en: 'Nationality',
    cat: 'Nacionalitat',
    eus: 'Nazionalitatea',
    pt: 'Nacionalidade'
  },
  REQUIRED_NATIONALITY: {
    es: 'Por favor, selecciona tu nacionalidad',
    en: 'Please select your nationality',
    cat: 'Si us plau, selecciona la teva nacionalitat',
    eus: 'Mesedez, hautatu zure nazionalitatea',
    pt: 'Por favor, selecione a sua nacionalidade'
  },
  SELECT_OPTION: {
    es: 'Selecciona una opción',
    en: 'Select an option',
    cat: 'Selecciona una opció',
    eus: 'Hautatu aukera bat',
    pt: 'Selecione uma opção'
  },
  BIRTH_DATA: {
    es: 'Datos de nacimiento',
    en: 'Birth data',
    cat: 'Dades de naixement',
    eus: 'Jaiotze datuak',
    pt: 'Dados de nascimento'
  },
  BIRTH_DATE: {
    es: 'Fecha de nacimiento',
    en: 'Date of birth',
    cat: 'Data de naixement',
    eus: 'Jaiotze data',
    pt: 'Data de nascimento'
  },
  REQUIRED_BIRTH_DATE: {
    es: 'Por favor, indica tu fecha de nacimiento',
    en: 'Please enter your date of birth',
    cat: 'Si us plau, indica la teva data de naixement',
    eus: 'Mesedez, adierazi zure jaiotze data',
    pt: 'Por favor, informe sua data de nascimento'
  },
  SELECT_BIRTH_DATE: {
    es: 'Selecciona tu fecha de nacimiento',
    en: 'Select your date of birth',
    cat: 'Selecciona la teva data de naixement',
    eus: 'Hautatu zure jaiotze data',
    pt: 'Selecione sua data de nascimento'
  },
  SEX: {
    es: 'Sexo',
    en: 'Sex',
    cat: 'Sexe',
    eus: 'Sexua',
    pt: 'Sexo'
  },
  REQUIRED_SEX: {
    es: 'Por favor, selecciona el sexo',
    en: 'Please select sex',
    cat: 'Si us plau, selecciona el sexe',
    eus: 'Mesedez, hautatu sexua',
    pt: 'Por favor, selecione o sexo'
  },

  FOREIGN_BIRTH_LOCALITY: {
    es: 'Localidad de nacimiento extranjera',
    en: 'Foreign birth locality',
    cat: 'Localitat de naixement estrangera',
    eus: 'Atzerriko jaiotze herria',
    pt: 'Localidade de nascimento estrangeira'
  },
  REQUIRED_FOREIGN_BIRTH_LOCALITY: {
    es: 'Por favor, completa la localidad de nacimiento',
    en: 'Please enter the birth locality',
    cat: 'Si us plau, completa la localitat de naixement',
    eus: 'Mesedez, sartu jaiotze herria',
    pt: 'Por favor, complete a localidade de nascimento'
  },
  FOREIGN_BIRTH_LOCALITY_PLACEHOLDER: {
    es: 'Completa la localidad de nacimiento',
    en: 'Enter birth locality',
    cat: 'Completa la localitat de naixement',
    eus: 'Sartu jaiotze herria',
    pt: 'Complete a localidade de nascimento'
  },
  ADDRESS_DATA: {
    es: 'Datos de domicilio',
    en: 'Address data',
    cat: 'Dades de domicili',
    eus: 'Helbide datuak',
    pt: 'Dados de domicílio'
  },
  SEARCH_ADDRESS: {
    es: 'Buscar dirección...',
    en: 'Search address...',
    cat: 'Cercar adreça...',
    eus: 'Helbidea bilatu...',
    pt: 'Pesquisar endereço...'
  },
  CONTRACT_SIGNED_TITLE: {
    es: '¡Contrato firmado!',
    en: 'Contract signed!',
    cat: 'Contracte signat!',
    eus: 'Kontratua sinatua!',
    pt: 'Contrato assinado!'
  },
  CONTRACT_SIGNED_SUBTITLE: {
    es: 'Tu contrato ha sido firmado correctamente. Pulsa "Continuar" para completar el proceso.',
    en: 'Your contract has been signed successfully. Click "Continue" to complete the process.',
    cat: 'El teu contracte ha estat signat correctament. Prem "Continuar" per completar el procés.',
    eus: 'Zure kontratua behar bezala sinatu da. Egin klik "Jarraitu" prozesua osatzeko.',
    pt: 'O teu contrato foi assinado com sucesso. Clica em "Continuar" para completar o processo.'
  }
};
